const TOKEN_KEY = 'checkin_token'
const ADMIN_KEY = 'checkin_admin'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function getAdmin() {
  const admin = localStorage.getItem(ADMIN_KEY)
  return admin ? JSON.parse(admin) : null
}

export function setAdmin(admin) {
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin))
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(ADMIN_KEY)
}

export function isAuthenticated() {
  return !!getToken()
}
